import PropTypes from 'prop-types';
import { useSelector } from 'react-redux';
import { ScrollArea } from 'src/@/components/ui/scroll-area';
import Iconify from 'src/components/Iconify';
import ChamadosCard from './ChamadosCard';
import { CHAMADOS_DESIGN } from 'src/sections/@dashboard/chamados/Chamados.design';

const D = CHAMADOS_DESIGN.kanban;
const LABELS = CHAMADOS_DESIGN.kanbanLabels;

const COLUMN_ICONS = {
  pendente: 'mdi:clock-outline',
  aberto: 'mdi:folder-open-outline',
  recusado: 'mdi:close-circle-outline',
};

KanbanColumn.propTypes = {
  column: PropTypes.object,
  index: PropTypes.number,
  listaTags: PropTypes.array,
};

export default function KanbanColumn({ listaTags, column, index }) {
  const { tickets } = useSelector((state) => state.chamados);
  const ticketsId = column ? column.ticketsId : [];
  const id = column ? column.id : null;
  const label = LABELS[id] || id;
  const icon = COLUMN_ICONS[id] || 'mdi:circle-slice-8';

  const columnCardClass = D.columnCard[id] || D.columnCard.pendente;
  const iconBoxClass = D.columnHeader.iconBox[id] || D.columnHeader.iconBox.pendente;
  const iconClass = D.columnHeader.icon[id] || D.columnHeader.icon.pendente;
  const countClass = D.columnHeader.count[id] || D.columnHeader.count.pendente;

  return (
    <div className={`${D.columnCard.base} ${columnCardClass}`}>
      <div className={D.columnHeader.wrapper}>
        <div className={D.columnHeader.inner}>
          <div className={D.columnHeader.left}>
            <div className={`${D.columnHeader.iconBox.base} ${iconBoxClass}`}>
              <Iconify icon={icon} className={iconClass} width={18} />
            </div>
            <h6 className={D.columnHeader.title}>{label}</h6>
          </div>
          <span className={`${D.columnHeader.count.base} ${countClass}`}>
            {ticketsId.length}
          </span>
        </div>
      </div>

      <div className={D.columnContent}>
        <ScrollArea className={D.columnScrollArea}>
          <div className={D.columnList}>
            {ticketsId.length > 0 &&
              ticketsId.map((cardId, idx) => (
                <ChamadosCard
                  listaTags={listaTags}
                  key={cardId}
                  onDeleteTask={() => {}}
                  card={tickets[cardId]}
                  index={idx}
                />
              ))}
            {ticketsId.length === 0 && (
              <div className={D.columnEmpty}>
                <div className={D.columnEmptyIcon}>
                  <Iconify icon="mdi:inbox-outline" width={20} />
                </div>
                <p className={D.columnEmptyText}>Nenhum ticket</p>
              </div>
            )}
          </div>
        </ScrollArea>
      </div>
    </div>
  );
}
